import * as queryString from "query-string";
import { StoreState } from "../types";
import { allValuesForFilter } from "./../../common/services/Filters";
import { apiFieldMappings } from "./../../refdata/FilterOptions";

export const encodeBrowserPathFromState = (query: StoreState.Query) => {
  const params = {} as any;
  // Translate all relevant parts of state to URL
  if (query.aggReport) {
    params.aggReport = query.aggReport;
  }
  apiFieldMappings.rangeSelect.forEach((f: any) => {
    if (query.filters[f.filterNameStart] && query.filters[f.filterNameEnd]) {
      params[f.filterNameStart] = query.filters[f.filterNameStart];
      params[f.filterNameEnd] = query.filters[f.filterNameEnd];
    }
  });
  apiFieldMappings.multiSelect.forEach((f: any) => {
    if (query.filters[f.filterName]) {
      // don't encode if equivalent to select-all
      if (
        query.filters[f.filterName].length !==
        allValuesForFilter(f.filterName).length
      ) {
        params[f.filterName] = query.filters[f.filterName].join(",");
      }
    }
  });
  apiFieldMappings.singleValues.forEach((f: any) => {
    if (query.filters[f.filterName]) {
      params[f.filterName] = query.filters[f.filterName];
    }
  });
  params.displayFields = query.displayFields.join(",");
  params.sortField = query.sort.sortField;
  params.sortOrder = query.sort.sortOrder;

  // Return the state string
  return `?${  queryString.stringify(params)}`;
};
